var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2224_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1176 54.989L25.7963 55.0009L25.2492 54.8986C21.2074 54.5651 17.368 53.3784 13.8345 51.3536L2.5793 55.0009H1.71989C0.868024 54.7512 0.249853 54.1337 0 53.2826V52.4241L3.65087 41.1809C1.60681 37.6165 0.415704 33.7389 0.0936949 29.6666L0 29.2288L0.0258469 25.8902L0.092618 25.3006C1.14696 11.9315 11.8045 1.17359 25.1942 0.126737L26.1312 0.0535757C27.0509 -0.0185096 27.9836 -0.0185096 28.9033 0.0535757L29.8413 0.126737C43.1815 1.16821 53.894 11.8616 54.9289 25.1887L55.0022 26.1259V28.8952L54.93 29.8313C53.895 43.2047 43.1126 53.8572 29.7304 54.9062L29.1197 54.9879L29.1176 54.989ZM13.4048 46.9768C14.0822 46.7595 14.7543 46.8896 15.2841 47.2189C23.1922 52.1217 33.266 51.7947 40.7756 46.5314C51.3157 39.1432 53.9284 24.7057 46.4867 14.178C42.1239 8.00555 35.0581 4.30123 27.4645 4.31737C19.915 4.33351 12.8997 8.01954 8.51116 14.221C3.17593 21.7609 2.90239 31.8529 7.78422 39.7252C8.14715 40.3105 8.23654 40.9776 8.02007 41.6489L5.48169 49.5234L13.4048 46.9768Z",
    fill: "#19147E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2286 24.8942C17.7493 24.5822 19.1008 25.5774 19.3916 26.9707C19.6824 28.3639 18.7498 29.8358 17.3066 30.1338C15.8915 30.4264 14.4947 29.5367 14.1609 28.1305C13.827 26.7243 14.6799 25.2116 16.2286 24.8931V24.8942Z",
    fill: "#19147E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9777 24.8942C28.4983 24.5822 29.8499 25.5774 30.1407 26.9707C30.4444 28.421 29.4988 29.8358 28.0557 30.1338C26.6126 30.4318 25.2438 29.5367 24.9099 28.1305C24.5728 26.7124 25.429 25.2116 26.9777 24.8931V24.8942Z",
    fill: "#19147E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7257 24.8942C39.2463 24.5822 40.5979 25.5774 40.8887 26.9707C41.1924 28.421 40.2468 29.8358 38.8037 30.1338C37.3886 30.4264 35.9918 29.5367 35.6579 28.1305C35.3208 26.7124 36.177 25.2116 37.7257 24.8931V24.8942Z",
    fill: "#19147E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2224_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.adda85e17398241449004530f373060c.svg";
export { ForwardRef as ReactComponent };